import { render, staticRenderFns } from "./RecoveredProjectDetail.vue?vue&type=template&id=ccb8f2dc&"
import script from "./RecoveredProjectDetail.vue?vue&type=script&lang=js&"
export * from "./RecoveredProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecoveredProjectDetail.vue?vue&type=style&index=0&id=ccb8f2dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports